<app-competency-modal
  [allCompetencies]="allCompetencies"
  [assignedCompetencies]="assignedCompetencies"
  [competencyGroups]="competencyGroups"
  [selectableCompetencyGroups]="selectableCompetencyGroups"
  [filterAction]="filterAction"
  [saveAction]="saveAction"
></app-competency-modal>
